import { render, staticRenderFns } from "./_base-deleteConfirm.vue?vue&type=template&id=0cfcf321&scoped=true&"
import script from "./_base-deleteConfirm.vue?vue&type=script&lang=js&"
export * from "./_base-deleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcf321",
  null
  
)

export default component.exports